module.exports = __webpack_public_path__ + "img/ENJ.83bb301e.svg";